import { Navigate, useLocation } from 'react-router-dom';
import { canAccessPath, useAuth } from './authContext';

// ProtectedRoute component with path-based access control for authenticated users
const ProtectedRoute = ({ element, path }) => {
  // Get authentication state and user's accessible paths from the auth context
  const { isAuthenticated, accessiblePaths } = useAuth();
  // Get the current location
  const location = useLocation();

  // Check if this is a QR code scan (re-authenticate each time)
  const queryParams = new URLSearchParams(location.search);
  const isQRCodeScan = queryParams.get('qrCode') === 'true';

  const hasPermission =
    isAuthenticated && canAccessPath(location.pathname, accessiblePaths);

  // Force re-authentication for QR code scans
  if (isQRCodeScan) {
    if (!isAuthenticated) {
      // Not authenticated - store the QR code flag and redirect to login
      localStorage.setItem('qrCodeRedirect', 'true');
      return <Navigate to='/login' state={{ from: location }} replace />;
    } else {
      // Already authenticated - still send to login for fresh MFA
      localStorage.setItem('qrCodeRedirect', 'true');
      return <Navigate to='/login' state={{ from: location }} replace />;
    }
  }

  // Redirect to login page if the user is not authenticated
  if (!isAuthenticated) {
    return <Navigate to='/login' state={{ from: location }} replace />;
  } else if (!hasPermission) {
    return <Navigate to='/denied' state={{ from: location }} replace />;
  }

  return element;
};

export { ProtectedRoute };
